var CareSin = class extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.clickCount = 0; // 添加点击计数器
  }

  connectedCallback() {
    // this._loadRecommendations();
  }

  init() {
    this.careVariants = this.querySelectorAll(".care-variant");
    if (this.careVariants) {
      this.careVariants.forEach((careVariant) => {
        careVariant.addEventListener("click", () => {
          this.handleVariantClick(careVariant);
        });
      });
    }
    this.error = this.querySelector(".care-variant-error");
    this.input = this.querySelector("input");
    this.care_learn_more = this.querySelector(".care_learn_more");
    this.care_drawer = document.querySelector("x-drawer.care_drawer"); // 修改为获取 x-drawer

  
  }
  // open() {
  //   const care_drawer = document.querySelector('x-drawer.care_drawer');
  //   console.log(care_drawer, 'care_drawer');
  //   const overlay = care_drawer.shadowRoot.querySelector('div[part="overlay"]');
  //   if (overlay) {
  //     overlay.style.display = 'block';
  //   }
  //   care_drawer.show();
  //   this.care_drawer.setAttribute('open', '');
  //   this.care_drawer.querySelector('[data-drawer-id="3"]')?.removeAttribute('hidden');
  //   this.care_drawer.querySelector('[data-drawer-id="1"]')?.setAttribute('hidden', '');
  //   this.care_drawer.querySelector('[data-drawer-id="2"]')?.setAttribute('hidden', '');
  //   // 设置垂直居中

  //   const height = this.care_drawer.offsetHeight;
  //   this.care_drawer.style.top = `calc( 50vh - ${height * 0.5} px)`;
  // }
  open() {
    if (!this.care_drawer) {
        console.error("Trade drawer not found");
      return;
    }
    this.care_drawer.querySelector(".care_button").style.display = "block";
    console.log(this.care_drawer, "care_drawer");
    const overlay = this.care_drawer.shadowRoot.querySelector('div[part="overlay"]');
    if (overlay) {
      overlay.style.display = "block";
    }
    this.care_drawer.show();
    this.care_drawer.setAttribute("open", "");

    // 设置垂直居中
    const height = this.care_drawer.offsetHeight;
    this.care_drawer.style.top = `calc(50vh - ${height * 0.5}px)`;
  }
  // 处理 Learn More 点击事件
  handleLearnMoreClick() {
    this.clickCount++;

    if (this.clickCount === 1) {
      // 第一次点击，打开最后一个 drawer
      this.open();
    } else {
      // 后续点击，显示前两个 drawer
      this.open();
      // 重置点击计数
      this.clickCount = 0;
    }
  }
  handleisButtonClick(event) {
    console.log(event, "event handleisButtonClick");
    this.careVariants.forEach((careVariant) => {
      careVariant.removeAttribute("careActive");
    });
    console.log(event.currentTarget, "this.careVariants");
    event?.setAttribute("careActive", true);

    if (this.error) {
      this.error.style.display = "none";
    }

    if (this.input) {
      this.input.value = event?.dataset.id || "";
    }

    const price = Number(event.dataset?.price || 0);
    const initialPriceText = document.querySelector(".rating-with-text sale-price");
    const usd = initialPriceText.dataset.priceCurrency.split(" ")[1];
    const initialPrice = initialPriceText.dataset.price;
    console.log(initialPrice, "initialPrice");
    const tradeIn = document.querySelector('trade-in input[name="tradein-device"]');
    const newPrice = `$${((price + Number(initialPrice) - Number(tradeIn?.dataset?.devicePrice || 0)) / 100).toFixed(
      2
    )} ${usd}`;
     document
      .querySelector(' .product-info__buy-buttons .buy-bottons_price price-list sale-price')
      .lastChild.replaceWith(document.createRange().createContextualFragment(newPrice));
    this.care_drawer.removeAttribute("open");
  }
  handleVariantClick(event) {
    console.log(event, "event handleVariantClick");
    const currentDataId = event.dataset.id;
    const previousActive = this.querySelector('.care-variant[careActive="true"]');
    const closeButton = this.care_drawer.querySelector(".care_button");
    closeButton.style.display = "block";
    if (currentDataId && currentDataId !== previousActive?.dataset.id) {
      this.open();
    }
    if (currentDataId) {
      if (closeButton) {
        closeButton.addEventListener("click", () => {
          this.handleisButtonClick(event);
        });
      }
    } else {
      this.handleisButtonClick(event);
    }
  }
};

if (!window.customElements.get("care-sin")) {
  window.customElements.define("care-sin", CareSin);
}
